<template>
  <div id="Subscriptions">
    <v-row no-gutters>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            <v-spacer/>
            <v-text-field
              style="max-width: 250px"
              dense
              outlined
              hide-details
              clearable
              :placeholder="$t('general.search')"
              v-model="search"
              append-icon="search"
              class="mr-2"
              @click:append="searching"
              @keyup.enter="searching"
            />
            <v-btn color="primary" depressed to="subscriptions/add">{{$t('subscriptions.add')}}</v-btn>
          </v-card-title>
          <v-card-text>
            <v-overlay absolute opacity="0" :value="loadTable"/>
            <v-data-table
              :search="search"
              :headers="headers"
              :items="subscriptions"
              :options.sync="options"
              :footer-props="{ 'items-per-page-options': [15, 25, 50] }"
              :server-items-length="options.total"
              :loading="loadTable"
              @update:page="get"
              @update:items-per-page="get"
              @update:sort-by="get"
              @update:sort-desc="get"
            >
              <template v-slot:item="props" >
                <tr>
                  <td>{{props.item.company ? props.item.company.name : '- -'}}</td>
                  <td>{{props.item.plan ? props.item.plan.name : '- -'}}</td>
                  <td>{{props.item.expiration_date}}</td>
                  <td>
                    <v-icon class="mr-4" small @click="edit(props.item.id)">far fa-edit</v-icon>
                    <v-icon small @click="remove(props.item)">far fa-trash-alt</v-icon>
                  </td>
                </tr>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-col>
    </v-row>
    <v-dialog v-model="dialog" width="500px">
      <v-card>
        <v-toolbar color="grey lighten-5" flat class="mb-5">
          <h3 class="error--text">{{$t('subscriptions.delete')}}</h3>
        </v-toolbar>
        <v-card-text>
          <p>{{$t('subscriptions.delMessage')}}?</p>
          <p><span class="font-weight-black error--text">{{$t('dashboard.subscription')}}: </span> {{removedItem.company.name}}</p>
          <p><span class="font-weight-black error--text">{{$t('general.expirationDate')}}: </span> {{removedItem.expiration_date}}</p>
        </v-card-text>
        <v-divider/>
        <v-card-actions>
          <v-spacer/>
          <v-btn
            color="error"
            text
            @click="close"
          >{{$t('general.cancel')}}</v-btn>
          <v-btn
            :disabled="loading"
            :loading="loading"
            color="error"
            depressed
            @click="confirmRemove"
          >{{$t('general.accept')}}</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
export default {
  name: 'Subscriptions',
  data () {
    return {
      dialog: false,
      loadTable: true,
      loading: false,
      search: '',
      pageCount: 0,
      pagination: [
        {text: '5', val: 5},
        {text: '10', val: 10},
        {text: '15', val: 15},
        {text: 'Todo', val: -1},
      ],
      options: {
        page: 1,
        itemsPerPage: 15,
        total: 0
      },
      subscriptions: [],
      removedItem: {
        company: {
          name: ''
        },
        expiration_date: ''
      }
    }
  },
  computed: {
    headers () {
      return [
        {
          text: this.$t('general.company'),
          value: 'company.name',
          sortable: true
        },
        {
          text: 'Plan',
          value: 'plan.name',
          sortable: true
        },
        {
          text: this.$t('general.expirationDate'),
          value: 'subscription.expiration_date',
          sortable: true
        },
        {
          text: this.$t('general.actions'),
          sortable: false
        }
      ]
    }
  },
  created () {
    this.get()
  },
  watch: {
    search (val) {
      if (val === '' || val === null) {
        this.options.itemsPerPage = 5
        this.get()
      }
    }
  },
  methods: {
    edit (id) {
      this.$router.push('/subscriptions/edit/' + id)
    },
    remove(item) {
      this.removedItem = item
      this.dialog = true
    },
    confirmRemove () {
      this.loading = true
      this.$store.dispatch('subscriptions/delete', {event: {item: this.removedItem, context: this}})
    },
    close () {
      this.dialog = false
      this.removedItem = {
        company: {
          name: ''
        },
        subscription: {
          expiration_date: ''
        }
      }
    },
    searching () {
      this.options.page = 1
      this.options.itemsPerPage = -1
      this.get()
    },
    get () {
      this.loadTable = true
      this.$store.dispatch('subscriptions/get', {
        event: {
          page: this.options.page,
          perPage: this.options.itemsPerPage,
          sortKey: this.options.sortBy ? this.options.sortBy[0] : undefined,
          ord: this.options.sortDesc && this.options.sortDesc[0] ? 'desc' : 'asc',
          find: this.search,
          context: this
        }
      })
    }
  }
}
</script>